<template>
<div>
  <div class="purcharse-order mt-1">
    
    <v-container :class="{'px-1': $vuetify.breakpoint.smAndDown}" fill-heigh>
      
      <v-layout row wrap>
        <v-flex xs12 md6 >
          <v-card>
       

        <v-card-title primary-title>
          <v-layout row wrap>
            <v-flex xs12>
              <v-btn icon @click="setStep(1)">
                <v-icon>arrow_back_ios</v-icon>
              </v-btn>  
            </v-flex>
           <v-flex xs12 md6>
          
            <img
              v-bind:src="'data:image/jpeg;base64,'+selectedImage"
            /> 
           </v-flex>
           <v-flex xs12 md6>
             <v-layout row wrap mb-4>
               <v-flex xs12>
                <div>
                    <h3 class="headline mb-0">{{product.serial_number}}</h3>
                    <div class="grey--text"> {{ product.sort_reference }} </div>
                  </div>  
                </v-flex>
                <v-flex xs12>
                    {{product.maker_name}}
                    <div right class="orange--text font-weight-black ">{{product.pesos_price * currentListPercentage | currency }}</div>
                    <!--div right class="text-xs-right">{{product.weigth_grams / 1000}} kg </div-->
                  </v-flex>
             </v-layout>
            </v-flex>
           
          </v-layout> 
          
        </v-card-title>
        <v-card-text>
          <v-layout row wrap  v-if="hasActivePurcharseOrder">
            <v-flex xs12>
              <purcharse-order-small-line-item-detail v-model="orderDetail.whole" label="1" ref="iW" />
            </v-flex>
            <v-flex xs12>
              <purcharse-order-small-line-item-detail v-model="orderDetail.three_quarter" label="3/4" ref="iTQ" />
            </v-flex>
            <v-flex xs12>
              <purcharse-order-small-line-item-detail v-model="orderDetail.half" label="1/2" ref="iH" />
            </v-flex>
            <v-flex xs12>
              <purcharse-order-small-line-item-detail v-model="orderDetail.quarter" label="1/4" ref="iQ" />
            </v-flex>
            <v-divider></v-divider>
            <v-layout row mb-4>
              <v-flex xs8 md8>
                <h2>Piezas</h2>
              </v-flex>
              <v-flex xs4 md4>
                <h2 class="grey--text text-xs-right">{{totalQuantity}}</h2>
              </v-flex>
            </v-layout>
            <v-layout row mb-4>
              <v-flex xs4 md4>
                <h1>Total</h1>
              </v-flex>
              <v-flex xs8 md8>
                <h1 class="orange--text font-weight-black text-xs-right">{{ lineTotal | currency}}</h1>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-text>
      </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</div>
</template>

<script>
export default {
  props: ['product'],
  data() {
    return {
      defaultOrderDetail: {
        quarter: 0,
        half: 0,
        three_quarter: 0,
        whole: 0,
      },
      orderDetail: {
        quarter: 0,
        half: 0,
        three_quarter: 0,
        whole: 0,
      },
      outline: false,
      solo: true,
      selectedImage: '',
      totalQuantity: 0.00,
      lineTotal: 0.00,
      systemPrice: true,
    };
  },
  watch: {
    product(newVal, oldVal) {
      this.loadProduct(newVal);
    },
    orderDetail: {
      handler(val) {
        this.totalQuantity = 1.00 * parseFloat(this.orderDetail.whole) +
          0.75 * parseFloat(this.orderDetail.three_quarter) +
          0.50 * parseFloat(this.orderDetail.half) +
          0.25 * parseFloat(this.orderDetail.quarter);

        this.lineTotal = this.totalQuantity * (this.product.pesos_price * currentListPercentage) ;
      },
      deep: true,
    },
  },
  computed: {
    activeRoute() {
      return this.$store.state.route.currentRoute;
    },
    hasActivePurcharseOrder() {
      return this.$store.getters.hasActivePurcharseOrder;
    },
    currentListPercentage() {
      if (this.$store.getters.getProfile && this.$store.getters.getProfile.currentList) {
        return this.$store.getters.getProfile.currentList.percentage / 100;
      }
      return 0;
    },
  },
  methods: {
    loadProduct(product) {
      /***
       * WATCH THIS, THIS IS THE MOCKUP,
       * when having the functional cart we must see if the serial number is in te card and
       * load that info instead
       */
      this.orderDetail.whole = 0;
      this.orderDetail.three_quarter = 0;
      this.orderDetail.half = 0;
      this.orderDetail.quarter = 0;

      const event = new Event('input');

      // This access to refs is necesary to update v-models on child elements, otherwise
      // the elements don't get updated
      if (this.$ref) {
        this.$refs.iW.set(this.orderDetail.whole);
        this.$refs.iTQ.set(this.orderDetail.three_quarter);
        this.$refs.iH.set(this.orderDetail.half);
        this.$refs.iQ.set(this.orderDetail.quarter);
      }

      this.axios.get(`/img/${product.picture_path}`)
        .then((result) => {
          this.selectedImage = result.data;
        }).catch((error) => {
          // console.log(error);
        });
    },
    setStep(step) {
      this.$emit('set-step', step);
    },
    addItem() {
      if (!this.$store.state.route.currentRoute) {
        this.$router.push('/route');
      }
    },
  },
};
</script>
